import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import VideosPage from "@/pages/VideosPage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CocoaLifePage from "@/pages/CocoaLifePage";
import AboutPage from "@/pages/AboutPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import AdminPage from "@/pages/AdminPage";
import PublicationsPage from "@/pages/publications/PublicationsPage";
import StarSungCompassPage from "@/pages/publications/StarSungCompassPage";
import BlueFlamePage from "@/pages/publications/BlueFlamePage";
import DonatePage from "@/pages/DonatePage";
import StoneInitiativePage from "@/pages/StoneInitiativePage";
import CoursesPage from "@/pages/CoursesPage";
import FAQPage from "@/pages/FAQPage";
import BookOrderPage from "@/pages/BookOrderPage";
import TruffleOrderPage from "@/pages/TruffleOrderPage";
import CocoaLifeOrderPage from "@/pages/CocoaLifeOrderPage";
import PreOrderPage from "@/pages/PreOrderPage";
import GamePage from "@/pages/GamePage";
import GamesPage from "@/pages/GamesPage";
import DarkPanRoutes from "@/dark-pan/DarkPanRoutes";
import TruthIsVerbPage from "@/pages/TruthIsVerbPage";
import EducatorsPage from "@/pages/EducatorsPage";
import QuizPage from "@/pages/QuizPage";
import LinesAndLyricsPage from "@/pages/LinesAndLyricsPage";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-background">
            <div className="noise-overlay" />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/videos" element={<VideosPage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:productId" element={<ProductPage />} />
                <Route path="/cocoalife" element={<CocoaLifePage />} />
                <Route path="/super-truffle" element={<CocoaLifePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/publications" element={<PublicationsPage />} />
                <Route path="/donate" element={<DonatePage />} />
                <Route path="/stone-initiative" element={<StoneInitiativePage />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/order-book" element={<BookOrderPage />} />
                <Route path="/order-truffles" element={<TruffleOrderPage />} />
                <Route path="/order-cocoalife" element={<CocoaLifeOrderPage />} />
                <Route path="/preorder" element={<PreOrderPage />} />
                <Route path="/educators" element={<EducatorsPage />} />
                <Route path="/games" element={<GamesPage />} />
                <Route path="/games/quiz" element={<QuizPage />} />
                <Route path="/games/music-gauntlet" element={<LinesAndLyricsPage />} />
                <Route path="/games/lines-and-lyrics" element={<LinesAndLyricsPage />} />
              </Route>
              {/* Game route - outside Layout for fullscreen */}
              <Route path="/game" element={<GamePage />} />
              {/* Dark Pan routes - outside Layout for immersive experience */}
              <Route path="/dark-pan/*" element={<DarkPanRoutes />} />
              {/* Truth Is Verb - PPC Framework - outside Layout for immersive experience */}
              <Route path="/truth-is-verb" element={<TruthIsVerbPage />} />
              {/* Oumuamua Books - outside Layout for immersive experience */}
              <Route path="/publications/star-compass" element={<StarSungCompassPage />} />
              <Route path="/publications/blue-flame" element={<BlueFlamePage />} />
            </Routes>
            <Toaster position="bottom-right" richColors />
          </div>
        </BrowserRouter>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
